import { DepartmentFilters } from '../store/slices/shared/types'

export const checkDepartmentFiltersHaveBeenApplied = (
  departmentFilters: DepartmentFilters,
): boolean => {
  return Object.values(departmentFilters).some(department => {
    if (!department) return false // Safety check for undefined

    return (
      department.selectedFilters.length > 0 ||
      department.selectedCategories.length > 0
    )
  })
}
